var _style, _circle, _path, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg7Lead = function Svg7Lead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "7_Lead_svg__Layer_2",
    x: 0,
    y: 0,
    viewBox: "0 0 100 100"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".7_Lead_svg__st0{fill:#40a0b2}.7_Lead_svg__st1{fill:#fb5e59}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 9,
    r: 9,
    className: "7_Lead_svg__st0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.94 42c.04-.33.06-.66.06-1a9 9 0 0 0-18 0c0 .34.02.67.06 1z",
    className: "7_Lead_svg__st0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 31,
    r: 7,
    className: "7_Lead_svg__st1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 20,
    r: 7,
    className: "7_Lead_svg__st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 42.5v8l25 25v23h15v-23l25-25v-8z",
    style: {
      fill: "none",
      stroke: "#10272d",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }));
};
export { Svg7Lead as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4wLjIsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMDAgMTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojNDBBMEIyO30NCgkuc3Qxe2ZpbGw6I0ZCNUU1OTt9DQoJLnN0MntmaWxsOm5vbmU7c3Ryb2tlOiMxMDI3MkQ7c3Ryb2tlLXdpZHRoOjM7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO30NCjwvc3R5bGU+DQo8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSI1OCIgY3k9IjkiIHI9IjkiLz4NCjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00NS45NCw0MmMwLjA0LTAuMzMsMC4wNi0wLjY2LDAuMDYtMWMwLTQuOTctNC4wMy05LTktOXMtOSw0LjAzLTksOWMwLDAuMzQsMC4wMiwwLjY3LDAuMDYsMUg0NS45NHoiLz4NCjxjaXJjbGUgY2xhc3M9InN0MSIgY3g9IjYzIiBjeT0iMzEiIHI9IjciLz4NCjxjaXJjbGUgY2xhc3M9InN0MSIgY3g9IjM3IiBjeT0iMjAiIHI9IjciLz4NCjxwb2x5Z29uIGNsYXNzPSJzdDIiIHBvaW50cz0iMTcuNSw0Mi41IDE3LjUsNTAuNSA0Mi41LDc1LjUgNDIuNSw5OC41IDU3LjUsOTguNSA1Ny41LDc1LjUgODIuNSw1MC41IDgyLjUsNDIuNSAiLz4NCjwvc3ZnPg0K";